import Container from '@components/ui/container';
import PageContactHeroSection from '@components/ui/page-contact-hero-section';
import ContactInformation from '@components/contact/contact-information';
import {useRouteLang} from 'src/hooks/use-route-lang';

export default function ContactUsPage() {
    const lang = useRouteLang();
    
    return (
        <>
            <PageContactHeroSection lang={lang}/>
            <Container>
                <div className="max-w-[1420px] mx-auto mb-12 lg:mb-14 xl:mb-16">
                </div>
                <ContactInformation lang={lang}/>
            </Container>
        </>
    );
}
